var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionReq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#FF9A6C",
    fillOpacity: 0.28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 57.02,
    fill: "#FF9A6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66 98.146c-18.284 0-33.145-14.862-33.145-33.146S47.716 31.854 66 31.854c18.284 0 33.146 14.862 33.146 33.146S84.284 98.146 66 98.146Zm0-61.667C50.275 36.48 37.48 49.275 37.48 65c0 15.725 12.795 28.52 28.52 28.52S94.521 80.726 94.521 65s-12.796-28.52-28.52-28.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.44 77.124a2.066 2.066 0 0 1-1.172-.34L66.71 71.08c-2.374-1.418-4.132-4.532-4.132-7.276V51.162a2.33 2.33 0 0 1 2.313-2.312 2.33 2.33 0 0 1 2.312 2.312v12.642c0 1.11.925 2.744 1.881 3.299l9.558 5.704c1.11.648 1.45 2.066.802 3.176a2.374 2.374 0 0 1-2.004 1.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionReq);
export default __webpack_public_path__ + "static/media/actionReq.fc4e1dd40a9a9b4f203713b8b144752a.svg";
export { ForwardRef as ReactComponent };